<template>
  <div
    class="partner-select"
    :class="{ 'partner-select--error': showError }">
    <v-select
      ref="vueSelect"
      v-model="value"
      :clearable="true"
      :components="{OpenIndicator}"
      :filterable="false"
      :options="options"
      :placeholder="placeholder"
      :taggable="taggable"
      @input="$emit('input', $event)"
      @search="onSearch">
      <template slot="no-options">
        {{ searchPlaceholder }}
      </template>
      <template
        slot="search"
        slot-scope="searchItem">
        <input
          ref="searchInputField"
          v-bind="searchItem.attributes"
          class="vs__search"
          :data-cy="testSelector"
          v-on="searchItem.events" />
      </template>
      <template
        slot="option"
        slot-scope="option">
        <div class="partner-select__select-option">
          {{ option.label }}
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        {{ option.label }}
      </template>
      <template v-slot:spinner="spinner">
        <div
          v-show="spinner.loading"
          class="cp-round cp-spinner"></div>
      </template>
    </v-select>
  </div>
</template>

<script>
  import VueSelect from 'vue-select';
  import config from '../../../../config';
  import 'vue-select/dist/vue-select.css';
  import FetchHelper from '../../../helpers/OldFetchHelper';
  import LocalStorageHelper from '../../../helpers/OldLocalStorageHelper';
  import PartnerShopMethods from '../../../methods/PartnerShopMethods';

  export default {
    components: {
      'v-select': VueSelect,
    },
    data() {
      return {
        OpenIndicator: {
          render: createElement => createElement(`span`, { class: `partner-select__icon` }),
        },
        isPartnerShop: false,
        options: [],
        value: ``,
      };
    },
    props: {
      mentorData: {
        default: null,
        type: Object,
      },
      placeholder: {
        default: ``,
        type: String,
      },
      searchPlaceholder: {
        default: ``,
        type: String,
      },
      showError: {
        default: false,
        type: Boolean,
      },
      taggable: {
        default: true,
        type: Boolean,
      },
      testSelector: {
        default: ``,
        type: String,
      },
    },
    async mounted() {
      await this.checkForPartnerShop();
      if(this.isPartnerShop) await this.setUpPartnerData();
    },
    methods: {
      ...PartnerShopMethods,
      clear() {
        this.$refs.vueSelect.clearSelection();
      },
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce(async (loading, /** @type {string} */ searchString, vm) => {
        if(!searchString || searchString.length < 3) {
          loading(false);
          return;
        }
        const response = await FetchHelper.post({ body: { searchString }, path: `/partners/search` });
        if(response.success) {
          // eslint-disable-next-line no-param-reassign
          vm.options = response.data.map(r => { return { ...r, code: r.partnerId, label: `${r.company ? r.company : `${r.firstName} ${r.lastName}`}- ${r.zipCode} ${r.city}` }; });

          /* exactly one result was found and the user entered only digits
           * really high chance he wanted to find a partner by partner number so blur and refocus the input field
           * input value is lost in the process, the user is forced to click on the found partner, ensures correct storing and linking in database
           */
          if(response.data.length === 1 && /^\d*$/.test(searchString)) {
            vm.$refs.searchInputField.blur();
            vm.$refs.searchInputField.focus();
          }
        }
        loading(false);
      }, 750),
      async setUpPartnerData() {
        const partnerData = LocalStorageHelper.getPartnerShopInformation();
        if(partnerData) {
          const fetchConfig = {
            body: {
              searchString: partnerData.customerNumber.toString(),
            },
            path: `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.search}`,
          };
          const fetchResult = await FetchHelper.post(fetchConfig);
          if(fetchResult.success) {
            const r = fetchResult.data[0];
            this.value = { ...r, code: r.partnerId, label: `${r.firstName} ${r.lastName} - ${r.zipCode} ${r.city}` };
            this.$emit(`input`, this.value);
          } else {
            console.info(`partner not found`); // is this even possible?
          }
        } else {
          await this.getPartnerShopInformation();
          await this.setUpPartnerData();
        }
      },
    },
    watch: {
      mentorData() {
        this.value = this.mentorData;
      },
    },
  };
</script>

<style lang="less" scoped>

  .partner-select {
    &__select-option {
      margin: 0;
      padding: 0;
    }

    &__icon {
      background-image: url('/wp-content/themes/JointsWP/assets/images/arrow-down.svg') !important;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 15px;
      height: 15px;
      padding-right: 27px;
      width: 15px;
    }
  }
</style>

<style lang="less">
  // non scoped style for vue-select overrides specific to this component
  @import '../../../assets/styles/rin-vue-select';

  .partner-select {
    &--error {
      .vs__dropdown-toggle {
        border-color: red;
        box-shadow: 0 0 5px red;
      }
    }

    .vs__dropdown-toggle,
    .vs__search,
    .vs__search:focus,
    .vs__selected {
      max-height: 38px;
    }
  }
</style>
